// extracted by mini-css-extract-plugin
export default {"table":"order_table__vDxEb","icons":"order_icons__iADTP","pending":"order_pending__Lnd2o","delivered":"order_delivered__KQvpu"};